import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
  } from "async-ops";

export const GET_SOURCE_LIST = "GET_SOURCE_LIST";
export const GET_SOURCES_REFERENCE_DATA = "GET_SOURCES_REFERENCE_DATA";

const initialState = {
    sourcesList:[],
    organizationTypeList:[]
}

export default function(state = initialState, action) {
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_SOURCE_LIST)(action)) {
        return { ...state,sourceList:[] };
      }
      if (isAsyncComplete(GET_SOURCE_LIST)(action)) {
        const response = action.response;
        return { ...state,sourcesList: response.sourcesList };
      }
      if (isAsyncOperation(GET_SOURCES_REFERENCE_DATA)(action)) {
        return { ...state,organizationTypeEnum:[] };
      }
      if (isAsyncComplete(GET_SOURCES_REFERENCE_DATA)(action)) {
        const response = action.response;
        return { ...state,organizationTypeList: response.organizationTypeList };
      }
      return state;
    default:
      return state;
  }
}